import { render } from "./license.vue?vue&type=template&id=38d80870&scoped=true"
const script = {}

import "./license.vue?vue&type=style&index=0&id=38d80870&lang=less&scoped=true"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d80870"]])

export default __exports__